// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'

import enumStore from './assets/js/EnumStore.js'
import store from './assets/js/store.js'
import {timeUtil, urlUtil} from './assets/js/util.js'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css'

import App from './App'
import router from './router'
import {formatter} from './assets/js/format.js'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(VueClipboard)

Vue.prototype.timeUtil = timeUtil
Vue.prototype.urlUtil = urlUtil
Vue.prototype._fm = formatter
Vue.prototype._enumStore = enumStore
// Vue.prototype.enum = {"ApplyStatus":ApplyStatus,"LCVType":LCVType,"GPSStatus":GPSStatus,"CompanyLicense":CompanyLicense};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  beforeCreate: function () {
    this._enumStore.dispatch('initCache')

    // TODO 这里可以加载完成所有的数据，然后渲染页面，需要在Promise.all中定义所有的数据/枚举调用接口
    Promise.all([]).then(() => {
      store.commit('finishedLoadingData')
    })
  }
})

Object.keys(formatter).forEach(function (key, index, arr) {
  Vue.filter(key, formatter[key])
})



// WEBPACK FOOTER //
// ./src/main.js